import { useEffect, useState } from 'react'
import Ticker from 'react-ticker'

const MoveStuffAround = ({ message }) => {

    // Ticker measures item width on mount; wait for web fonts so the
    // measured width matches the rendered text (otherwise the next copy
    // overlaps and hides the end of the message).
    const [fontsReady, setFontsReady] = useState(false)

    useEffect(() => {
        let active = true
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => { if (active) setFontsReady(true) })
        } else {
            setFontsReady(true)
        }
        return () => { active = false }
    }, [])

    if (!fontsReady) return null

    // console.log(message)
    return (
        <Ticker
            key={message}
            mode={"smooth"}
            speed={4}
        // move={true}
        >
            {({ index }) => (
                <p className="alert_msg_text" key={index}>{message}</p>
            )}
        </Ticker>
    )
}

export default MoveStuffAround
